import React, {Component} from 'react';
import { Link } from 'react-router-dom'; 
import { base_url} from '../common/Constants'; 
import { SharedContext } from '../pages/createContext';
import withRouter from '../components/withRouter';

class Header extends Component {
    static contextType = SharedContext;
    
    constructor(props){
        super(props);
        
        this.state = {
            scrolled: false,
            slug : "",
            mobile:0,
            mobileAbout:'closed',
            mobileDivision:'closed',
            mobileProjects:'closed',
            isMenuClosed : true,
            isServicesClosed:true,
            isPeopleClosed:true,
            exploreMobile:0,
            aboutMobile:0,
            approachMobile:0,
            foundationMobile:0,
            servicesMobile:0,
            activeCategory: null,
            clientsMobile:0
          };
        }
      
        componentDidMount() {
          window.addEventListener('scroll', this.handleScroll);

          const slug = ((this.props.slug || '').split('/').filter(Boolean)[0]) ?? this.props.slug;

          this.setState({ slug: slug}); 
          
        }
      
        componentWillUnmount() {
          window.removeEventListener('scroll', this.handleScroll);
        }
      
        handleScroll = () => {
          const isScrolled = window.scrollY > 50;
          if (isScrolled !== this.state.scrolled) {
            this.setState({ scrolled: isScrolled });
          }
        }; 

        onClose = () => {
           
            this.setState({ isMenuClosed: true });
          
        }; 
        
        onCloseServices = () => {
           
            this.setState({ isServicesClosed: true });
          
        };
        onClosePeople = () => {
           
            this.setState({ isPeopleClosed: true });
          
        };
         onOpenPeople = () => {
           
            this.setState({ isMenuClosed: true ,  isServicesClosed: true  ,  isPeopleClosed: false });
          
        }; 
 
        onOpenExplore = () => {
           
            this.setState({ isMenuClosed: false ,  isServicesClosed: true,  isPeopleClosed: true });
          
        }; 

        onOpenServices = () => {
           
            this.setState({ isMenuClosed: true , isServicesClosed: false,  isPeopleClosed: true });
          
        }; 

      closeMobileMenu = (event) => { this.setState({mobile:  0}); }
      handleMobileMenu = (event) => { this.setState({mobile:this.state.mobile === 0 ? 1 : 0}); }
      handleAbout = (event) => { this.setState({mobileAbout:this.state.mobileAbout === 'closed' ? 'open' : 'closed'});}
      handleDivision = (event) => { this.setState({mobileDivision:this.state.mobileDivision === 'closed' ? 'open' : 'closed'});}
      handleProjects = (event) => { this.setState({mobileProjects:this.state.mobileProjects === 'closed' ? 'open' : 'closed'});}

      onOpenMobileExplore = (event) => {  this.setState({exploreMobile:this.state.exploreMobile === 0 ? 1 : 0, servicesMobile:0,activeCategory:null,clientsMobile:0});   }
      onOpenMobileServices = (event) => {  this.setState({servicesMobile:this.state.servicesMobile === 0 ? 1 : 0, exploreMobile:0,  approachMobile:0,foundationMobile:0,clientsMobile:0, aboutMobile:0});   }
      onOpenMobileClients = (event) => {  this.setState({clientsMobile:this.state.clientsMobile === 0 ? 1 : 0, servicesMobile:0,exploreMobile:0, approachMobile:0,foundationMobile:0, aboutMobile:0,activeCategory:null});   }
      onOpenMobileAbout = (event) => {  this.setState({aboutMobile:this.state.aboutMobile === 0 ? 1 : 0, approachMobile:0,foundationMobile:0});   }
      onOpenMobileApproach = (event) => {  this.setState({approachMobile:this.state.approachMobile === 0 ? 1 : 0, aboutMobile:0,foundationMobile:0});   }
      onOpenMobileFoundation = (event) => {  this.setState({foundationMobile:this.state.foundationMobile === 0 ? 1 : 0, aboutMobile:0, approachMobile:0});   }
      toggleCategory = (index) => {
  this.setState({
    activeCategory:
      this.state.activeCategory === index ? null : index,
  });
};
      

      
    render()
    {
        const people = base_url+"assets/_nuxt/img/people.288d8ac.jpg";
        const clients = base_url + "assets/_nuxt/img/clients.5e3b0d4.jpg";
        const partners = base_url + "assets/_nuxt/img/partner.1cab008.jpg";;
        const nav_bg = base_url + "assets/_nuxt/img/nav_bg.jpg";;
        const categories = JSON.parse(localStorage.getItem("categories"));

        const blogs = JSON.parse(localStorage.getItem("blogs"));
        const blog_index = blogs.length - 1;

        
     
  return (
    <div>

 <link data-v-e8f34808="" to="/https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&amp;display=swap" rel="stylesheet"/>
     <nav data-v-e8f34808="">
      <div class="top-nav">
       <div class="top-nav-container">
        <Link  data-aos="fade-in" data-aos-delay="1300" to={base_url+`downloads`} style={{marginLeft:'auto'}}>
         DOWNLOADS
       </Link>
        <Link data-aos="fade-in" data-aos-delay="1400" to={base_url+`careers`}>
         Careers
       </Link>
        <Link data-aos="fade-in" data-aos-delay="1500" to={base_url+`contact-us`}>
         Contact Us
       </Link>
        <Link data-aos="fade-in" data-aos-delay="1500" to={base_url+`portals`}>
         <strong>
          Portals
         </strong>
       </Link>
       </div>
      </div>
      <div class="main-nav">
       <div class="main-nav-container">
        <Link aria-current="page" class="logo nuxt-link-exact-active nuxt-link-active" data-aos="zoom-in" to="/">
         <img alt="Esco Logo" src={JSON.parse(localStorage.getItem("settings")).site_logo}/>
       </Link>
        <div class="nav-items">
         <div class="master-nav" data-aos="fade-in" data-aos-delay="100" id="explore" onMouseOver={this.onOpenExplore}>
          Explore
         </div>
         <div class="master-nav" data-aos="fade-in" data-aos-delay="200"  onMouseOver={this.onOpenServices}>
          Services
         </div>
         <div class="master-nav" data-aos="fade-in" data-aos-delay="300"  onMouseOver={this.onOpenPeople}>
          Stakeholder
         </div>
         <Link data-aos="fade-in" data-aos-delay="500"  to={base_url+`news`}   onMouseOver={this.onOpenNews}>
          <span>
           News
          </span>
        </Link>
         <Link aria-label="Search Button" class="search-icon" data-aos="fade-in" data-aos-delay="700" to="/search">
          <span>
           <svg
    id="b"
    viewBox="0 0 21.23 21.23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="c">
      <path
        style={{ fill: "#eaeaea", fillRule: "evenodd" }}
        d="m14.41,4.23c-2.81-2.81-7.37-2.81-10.18,0-2.81,2.81-2.81,7.37,0,10.18,
           2.81,2.81,7.37,2.81,10.18,0s2.81-7.37,0-10.18h0ZM2.73,2.73C6.37-.91,
           12.27-.91,15.91,2.73c3.39,3.39,3.62,8.73.71,12.39l4.3,4.3c.41.41.41,
           1.09,0,1.5-.41.41-1.09.41-1.5,0l-4.3-4.3c-3.66,2.91-9,2.68-12.39-.71
           C-.91,12.27-.91,6.37,2.73,2.73Z"
      />
    </g>
  </svg>
          </span>
        </Link>
        </div>
          <div className="large-sub-container" style={{ display : this.state.isMenuClosed ? 'none' : "block" }} onMouseLeave={this.onClose}>
      <button
        type="button"
        className="close-button"
        aria-label="Close"
        onClick={this.onClose}
      >
        X
      </button>

      <div data-aos="fade-in" className="large-nav aos-init aos-animate">
        <div className="left-group">
          <div className="top-group">
            <div className="ln-group">
              <Link to={base_url+`explore/about-esco`} className="ln-head">
                <strong>About ESCO</strong>
              </Link>
              <span>
                <Link to={base_url+`who-we-are`} >Who We Are</Link>
                <Link to={base_url+`what-we-do`}>What We Do</Link>
                <Link to={base_url+`our-journey`}>Our Journey</Link>
                <Link to={base_url+`structure`}>Structure</Link>
                <Link to={base_url+`purpose-and-value`}>
                  Purpose &amp; Value
                </Link>
                <Link to={base_url+`ecosystem`}>Ecosystem</Link>
              </span>
            </div>

            <div className="ln-group">
              <Link to={base_url+`explore/approach`} className="ln-head">
                <strong>Approach</strong>
              </Link>
              <span>
                <Link to={base_url+`how-we-do-it`}>How We Do It</Link>
                <Link to={base_url+`why-are-we-different`}>
                  Why are we different
                </Link>
                <Link to={base_url+`governance`}>Governance</Link>
                <Link to={base_url+`health-and-safety`}>
                  Health and Safety
                </Link>
              </span>
            </div>

            <div className="ln-group">
              <Link to={base_url+`explore/foundation`} className="ln-head">
                <strong>FOUNDATION</strong>
              </Link>
              <span>
                <Link to={base_url+`natural-heritage`}>
                  Natural Heritage
                </Link>
                <Link to={base_url+`energy-transition`}>
                  Energy Transition
                </Link>
                <Link to={base_url+`hydrogen`}>Hydrogen</Link>
                <Link to={base_url+`sustainability`}>
                  Sustainability
                </Link>
                <Link to={base_url+`in-country-value`}>
                  In Country Value
                </Link>
              </span>
            </div>
          </div>

          <div className="bottom-group">
            <Link to={base_url+`diversity-strategy-2030`}>Diversity Strategy 2030</Link>
            <Link to={base_url+`key-figures`}>Key Figures</Link>
            <Link to={base_url+`abudhabi`}>About Abu Dhabi</Link>
          </div>
        </div>

        {blogs[blog_index] && 

        <Link
          to={base_url+`news-info/`+blogs[blog_index].slug}
          className="right-group"
        >
          <div className="highimage">
            <img
              src={blogs[blog_index].image}
              alt={blogs[blog_index].title}
            />
          </div>

          <div className="nh-content">
            <h4>{blogs[blog_index].title}</h4>
            <p>{blogs[blog_index].short_info.slice(0, 100)}</p>
          </div>
        </Link>
    }
      </div>
    </div>
     <div className="large-sub-container" style={{ display : this.state.isServicesClosed ? 'none' : "block" }} onMouseLeave={this.onCloseServices}>
       <button
        type="button"
        className="close-button"
        aria-label="Close"
        onClick={this.onCloseServices}
      >
        X
      </button>
     <div
        data-v-6d194c94=""
        data-aos="fade-in"
        className="large-nav aos-init aos-animate"
      >
        <div data-v-6d194c94="" className="left-group">
          <div data-v-6d194c94="" className="top-group">

             {categories.map((item,key)=>(
            
              
            <div data-v-6d194c94="" className="ln-group">
              <div data-v-6d194c94="" className="dropped">
                <img
                  data-v-6d194c94=""
                  src={item.image}
                  alt={item.title}
                />
              </div>

             <Link data-v-6d194c94="" to={base_url+`service-category/`+item.slug} className="ln-head">
                <strong>{item.title}</strong>
             </Link>

              <span data-v-6d194c94="">
               { item.services.length > 0 &&  
                 item.services.map((seritem,serkey)=>(
                <Link data-v-6d194c94="" to={base_url+`services/${seritem.slug}`}  >
                  {seritem.title}
                </Link> 
                ))} 
              </span>
            </div>
             ))}
            
 
          </div>
        </div>
      </div>
      </div>
 <div className="large-sub-container" style={{ display : this.state.isPeopleClosed ? 'none' : "block" }} onMouseLeave={this.onClosePeople}>
   <button
        type="button"
        className="close-button"
        aria-label="Close"
        onClick={this.onClosePeople}
      >
        X
      </button>
       <div
      data-v-e4998a9c=""
      data-aos="fade-in"
      className="large-nav aos-init aos-animate"
    >
      <div data-v-e4998a9c="" className="left-group">
        <div data-v-e4998a9c="" className="top-group">
          
          {/* Our People */}
         <Link data-v-e4998a9c="" to={base_url+`stakeholders/people`} className="ln-group">
            <div data-v-e4998a9c="" className="ln-head">
              <strong>Our People</strong>
            </div>

            <p data-v-e4998a9c="" style={{ textTransform: "none" }}>
              Our people are our greatest assets. The driving force behind our success, 
              delivering excellence with passion and dedication.
            </p>

            <img
              data-v-e4998a9c=""
              src={people}
              className="dropped"
              alt="Our People"
            />
         </Link>

          {/* Our Clients */}
         <Link data-v-e4998a9c=""  to={base_url+`stakeholders/clients`} className="ln-group">
            <div data-v-e4998a9c="" className="ln-head">
              <strong>Our Clients</strong>
            </div>

            <p data-v-e4998a9c="" style={{ textTransform: "none" }}>
              Our Clients are our Partners too. Together, we ignite innovation and unlock 
              transformative solutions, shaping the future of our industry.
            </p>

            <img
              data-v-e4998a9c=""
              src={clients}
              className="dropped"
              alt="Our Clients"
            />
         </Link>

          {/* Our Partners */}
         <Link data-v-e4998a9c="" to={base_url+`stakeholders/partners`} className="ln-group">
            <div data-v-e4998a9c="" className="ln-head">
              <strong>Our Partners</strong>
            </div>

            <p data-v-e4998a9c="" style={{ textTransform: "none" }}>
              Enhancing innovative technical solutions. Fueling relentless innovation 
              and transformative solutions through strategic collaboration.
            </p>

            <img
              data-v-e4998a9c=""
              src={partners}
              className="dropped"
              alt="Our Partners"
            />
         </Link>

        </div>
      </div>
    </div>
     </div>
       </div>
      
      </div>
     </nav>
     <div className={this.state.mobile == 1 ? "mobile-nav dnone" :  "mobile-nav dblock" } data-v-5d2963cd="" data-v-e8f34808="" onClick={this.handleMobileMenu}>
      <div class="nav-icon-container" data-v-5d2963cd="">
       <svg class="nav-icon" data-v-5d2963cd="" viewbox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <g data-v-5d2963cd="" stroke-linecap="round">
         <path class="svgfill svgstroke" d="M72 82.286h28.75" data-v-5d2963cd="" fill-rule="evenodd">
         </path>
         <path class="svgstroke svgnofill" d="M100.75 103.714l72.482-.143c.043 39.398-32.284 71.434-72.16 71.434-39.878 0-72.204-32.036-72.204-71.554" data-v-5d2963cd="">
         </path>
         <path class="svgfill svgstroke" d="M72 125.143h28.75" data-v-5d2963cd="" fill-rule="evenodd">
         </path>
         <path class="svgstroke svgnofill" d="M100.75 103.714l-71.908-.143c.026-39.638 32.352-71.674 72.23-71.674 39.876 0 72.203 32.036 72.203 71.554" data-v-5d2963cd="">
         </path>
         <path class="svgfill svgstroke" d="M100.75 82.286h28.75" data-v-5d2963cd="" fill-rule="evenodd">
         </path>
         <path class="svgfill svgstroke" d="M100.75 125.143h28.75" data-v-5d2963cd="" fill-rule="evenodd">
         </path>
        </g>
       </svg>
      </div>
     </div>

      

     <div
  className={this.state.mobile == 0 ? "NavBlock aos-init aos-animate dnone" :  "NavBlock aos-init aos-animate dblock" }
  data-aos="fade-right"
  data-aos-duration="400"
  style={{
    backgroundImage:
      'url('+nav_bg+')',
    backgroundPosition: 'left center',
    backgroundSize: 'cover',
  }}
>
  <div className="nb-content">

    <div className={this.state.mobile == 0 ? "mobile-nav dnone" :  "mobile-nav dblock" } data-v-5d2963cd="" data-v-e8f34808="" onClick={this.handleMobileMenu}>
        <div class="nav-icon-close">X</div>
      </div>
    <div className="nb-main">
      
      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"
        >
          <span>
            <Link to={base_url+`search`} >Search</Link>
          </span>
        </div>
      </div>

      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"
          onClick={this.onOpenMobileExplore}
        >
          <span>Explore</span>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" onClick={this.onOpenMobileAbout}  className={this.state.exploreMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} ><span>About ESCO</span></div>
        <div className={this.state.aboutMobile == 1 ? "dblock" : "dnone"} >
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`who-we-are`} >Who We Are</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`what-we-do`}>What We Do</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`our-journey`}>Our Journey</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
         <Link to={base_url+`structure`}>Structure</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`purpose-and-value`}>Purpose &amp; Value</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`ecosystem`}>Ecosystem</Link>
        </div>
      </div> 

       <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" onClick={this.onOpenMobileApproach}  className={this.state.exploreMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} ><span>Approach</span></div>
        <div className={this.state.approachMobile == 1 ? "dblock" : "dnone"} >
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`how-we-do-it`}>How We Do It</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`why-are-we-different`}>Why are we different</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`governance`}>Governance</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`health-and-safety`}>Health and Safety</Link>
        </div> 
      </div> 
 
        
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300"  onClick={this.onOpenMobileFoundation} className={this.state.exploreMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} ><span>Foundation</span></div>
        
         <div className={this.state.foundationMobile == 1 ? "dblock" : "dnone"} >
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`natural-heritage`}>Natural Heritage</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
           <Link to={base_url+`energy-transition`}>Energy Transition</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
            <Link to={base_url+`sustainability`}>Sustainability</Link>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300" class="nb-item aos-init aos-animate" onClick={this.closeMobileMenu}>
          <Link to={base_url+`in-country-value`}>In Country Value</Link>
        </div> 
      </div> 
 
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300"  className={this.state.exploreMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} ><span><Link to={base_url+`abudhabi`}>About Abudhabi</Link></span></div>
       
      </div>

      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"
          onClick={this.onOpenMobileServices}
        >
          <span>Services</span>
        </div>

     {categories.map((item, key) => (
  <div key={key}>
    {/* CATEGORY TITLE */}
    <div
      data-aos="fade-left"
      data-aos-duration="300"
      className={this.state.servicesMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} 
      onClick={() => this.toggleCategory(key)}
    >
      <span>{item.title}</span>
    </div>

    {/* INNER SERVICES */}
    {this.state.activeCategory === key &&
      item.services.length > 0 && (
        <div className="dblock">
          {item.services.map((seritem, serkey) => (
            <div
              key={serkey}
              data-aos="fade-left"
              data-aos-duration="300"
              className="nb-item"
              onClick={this.closeMobileMenu}
            >
              <Link to={`${base_url}services/${seritem.slug}`}>
                {seritem.title}
              </Link>
            </div>
          ))}
        </div>
      )}
  </div>
))}

      </div>

      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"
          onClick={this.onOpenMobileClients}
        >
          <span>Stakeholders</span>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300"  onClick={this.closeMobileMenu} className={this.state.clientsMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} >
          <span> <Link to={base_url+`stakeholders/people`} className="ln-group">Our People</Link></span>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300"  onClick={this.closeMobileMenu} className={this.state.clientsMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} >
          <span> <Link to={base_url+`stakeholders/clients`} className="ln-group">Our Clients</Link></span>
        </div>
        <div data-aos="fade-left" data-aos-delay="0" data-aos-duration="300"  onClick={this.closeMobileMenu} className={this.state.clientsMobile == 1 ? "dblock nb-head aos-init aos-animate" : "dnone"} >
          <span> <Link to={base_url+`stakeholders/partners`} className="ln-group">Our Partners</Link></span>
        </div>
        
      </div>

      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"   onClick={this.closeMobileMenu}
        >
          <span>
            <Link to={base_url+`news`}>News</Link>
          </span>
        </div>
      </div>

      <div className="nb-group">
        <div
          className="nb-section aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="200"   onClick={this.closeMobileMenu}
        >
          <span>
            <Link to={base_url+`contact-us`}>Contact Us</Link>
          </span>
        </div>
      </div>
    </div>

    <div className="nb-footer">
      <Link to={base_url+`downloads`}  className="nbf-item"   onClick={this.closeMobileMenu}>Downloads</Link>
      <Link to={base_url+`portals`}  className="nbf-item"   onClick={this.closeMobileMenu}>Portals</Link>
      <Link to={base_url+`careers`}  className="nbf-item"   onClick={this.closeMobileMenu}>Careers</Link>
     
    </div>
  </div>
</div>

     
     <div class="scroll-to-top" data-v-4d2ef339="" data-v-e8f34808="">
      <img alt="scroll to top" class="st-arrow" data-v-4d2ef339="" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJiIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi43NCAyMi42NiI+PGRlZnM+PHN0eWxlPi5ke2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9ImMiPjxnPjxwb2x5Z29uIGNsYXNzPSJkIiBwb2ludHM9IjEyLjc0IDYuMzIgMTIuNzQgMCA2LjM3IDYuMzcgMCAwIDAgNi4zMiA2LjM3IDEyLjY5IDEyLjc0IDYuMzIiLz48cG9seWdvbiBjbGFzcz0iZCIgcG9pbnRzPSIxMi43NCAxNi4yOSAxMi43NCA5Ljk3IDYuMzcgMTYuMzQgMCA5Ljk3IDAgMTYuMjkgNi4zNyAyMi42NiAxMi43NCAxNi4yOSIvPjwvZz48L2c+PC9zdmc+"/>
     </div>  
    </div>
    
     
    
  );
}
};
 
export default withRouter(Header);;